import { BIGDeviceOperationMode } from "src/components/shared-components/enum/enumDevice";
import { UsersRole } from "src/model/enum/enumDigitalPlace";
import { IPVerificationStatus } from "src/model/enum/server-ip-verification";

export class Building {
  public id: number;
  public name: string = "";
  public address: string = "";
  public city: string = "";
  public province: string = "";
  public latitude: string = "";
  public longitude: string = "";
  public idAreaLocal: number = -1;
  public energyCoefficient: number = 0;
  public BACSCoefficient: number = 0;
  public taxCode: string = "";
  public integrationCH: boolean = false;
  public integrationBU: boolean = false;
  public default: boolean = false; // This field is used to identify the demo condominium, on which the user can only partially interact, it is taken from the corresponding area on BIGStudio

  constructor(building?: any) {
    // used for assign type to instance of object
    if (building) {
      Object.assign(this, building);
    }
  }
}

export class InvitationBuilding {
  public id: string = "";
  public idBuilding: number;
  public creationDate: string = "";
  public elaborated: boolean;
  public email: string = "";
  public expirationTokenDate: string = "";
  public idUser: number;
  public sentEmail: boolean;
  public token: string;
  public updateDate: boolean;
  public role: UsersRole;
  public idUserRemote: number = 0;

  constructor(building?: any) {
    // used for assign type to instance of object
    if (building) {
      Object.assign(this, building);
    }
  }
}

export class InvitationAwaiting {
  public idInvitation: string = "";
  public idBuilding: number;
  public token: string = "";
  public email: string;
  public expirationTokenDate: string = "";
  public creationDate: string = "";
  public surname: string;
  public name: string;
  public idUser: number;
  public descriptionBuilding: string;

  constructor(building?: any) {
    // used for assign type to instance of object
    if (building) {
      Object.assign(this, building);
    }
  }
}
